import i18n from "./i18n";

class Utility {
  constructor() {
    this.map = {
      ENFP: { en: 'clownfish', cy: 'pysgodyn-clown' },
      ENFJ: { en: 'dolphin', cy: 'ddolffin' },
      INFJ: { en: 'seahorse', cy: 'morfarch' },
      INFP: { en: 'seal', cy: 'morlo' },
      ISFJ: { en: 'koala-bear', cy: 'arth-coala' },
      ISTJ: { en: 'polar-bear', cy: 'arth-wen' },
      ESTJ: { en: 'black-bear', cy: 'arth-ddu' },
      ESFJ: { en: 'panda', cy: 'panda' },
      ENTJ: { en: 'eagle', cy: 'eryr' },
      INTJ: { en: 'barn-owl', cy: 'tylluan-wen' },
      INTP: { en: 'tawny-owl', cy: 'tylluan-frech' },
      ENTP: { en: 'falcon', cy: 'hebog' },
      ESFP: { en: 'lion', cy: 'llew' },
      ESTP: { en: 'panther', cy: 'panther' },
      ISTP: { en: 'tiger', cy: 'teigr' },
      ISFP: { en: 'cat', cy: 'cath' },
    };
  }

  lookupAnimalCode(machineName) {
    let animalCode = null;

    Object.keys(this.map).forEach(code => {
      if (this.map[code][i18n.language] === machineName) {
        animalCode = code;
      }
    });

    return animalCode;
  }

  lookupSlug(code) {
    return this.map[code][i18n.language];
  }

  lookupMachineNameTranslation(machineName) {
    let machineNameTranslation = null;

    Object.keys(this.map).forEach(code => {
      if (this.map[code][i18n.language] === machineName) {
        machineNameTranslation = this.map[code][i18n.language === 'en' ? 'cy' : 'en'];
      }
    });

    return machineNameTranslation;
  }

  formatMachineNameAsSlug(machineName) {
    return machineName.replace('_', '-');
  }

  formatSlugAsMachineName(slug) {
    return slug.replace('-', '_');
  }

  mode(array) {
    array = [...array];
    return array.sort((a, b) => array.filter(v => v === a).length - array.filter(v => v === b).length ).pop();
  };
}

export default (new Utility());
